import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as AddNewField } from "assets/icons/Group 239993.svg";
import { ReactComponent as DeleteCost } from "assets/icons/PendingIcon.svg";
import {
  InputField,
  InputFieldWithCheckbox,
  LabelField,
  MyCheckbox,
  SelectField,
} from "components";
import Button from "components/button/Button";
import AddInstallmentsPayment from "components/Installments/AddInstallmentsPayment";
import PricingTabs from "components/pricingTabs/PricingTabs";
import RadioButtons from "components/RadioButtons/RadioButtons";
import {
  getDateFormat,
  getDateFormatForDatePicket,
  maskDate,
} from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import FinanceService from "../../../../../Lib/API/Finance";
import "./CostInfo.scss";
import LedgersMenu from "./LedgersMenu";
import OptionalTypesItems from "./OptionalTypesItems";
import PaymentTypeSelect from "./PaymentTypeSelect";
import "./Pricing.scss";
import Stack from "@mui/material/Stack";
import InfoTooltip from 'components/InfoTooltip';
import { fontConfig } from "theme/fontConfig";


const PriceInfo = ({ formik }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [costActive, setCostActive] = useState(0);
  const orgDetails = getOrganizationInfoFromLocalStorage();
  const enableInstallments = orgDetails?.allowInstallments;

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const currency = getCurrency();

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormate || "mm/dd/yyyy"
  );

  useEffect(() => {
    async function getLedgeraccounts() {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const res = await FinanceService.getLedgerSubLedgerList(token);
        if (res?.ledgers) {
          setLedgers(res?.ledgers);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
//   const hasPriceError = (index) => {
//   if (!formik.errors?.prices?.[index]) return false;

//   const checkDeep = (obj) =>
//     Object.values(obj).some((val) =>
//       typeof val === "object" && val !== null
//         ? checkDeep(val)
//         : Boolean(val)
//     );

//   return checkDeep(formik.errors.prices[index]);
// };
const hasPriceError = (index) => {
  const errors = formik.errors?.prices?.[index];
  const touched = formik.touched?.prices?.[index];

  if (!errors) return false;

  const check = (errObj, touchObj) => {
    return Object.keys(errObj || {}).some((key) => {
      const errVal = errObj[key];
      const touchVal = touchObj?.[key];

      if (typeof errVal === "object" && errVal !== null) {
        return check(errVal, touchVal);
      }

      if (key === 'minAmount') return Boolean(errVal);
      return Boolean(errVal) && Boolean(touchVal);
    });
  };

  return check(errors, touched);
};
  const handleBeforeAddPrice = async () => {
    const errors = await formik.validateForm();
    const hasPriceErrors =
      Array.isArray(errors?.prices) &&
      errors.prices.some((e) => e && Object.keys(e).length > 0);

    if (hasPriceErrors) {
      const newTouched = { ...formik.touched };
      newTouched.prices = formik.values.prices.map((price, i) => {
        const existing = formik.touched?.prices?.[i] || {};
        const fields = { ...existing, amount: true, quantity: true, minAmount: true, ledger: true };
        if (price.isInstallmentTransaction) {
          fields.installmentDetailsTransaction = { numberOfInstallment: true };
        }
        if (price.variant && Array.isArray(price.variantInfo)) {
          fields.variantInfo = price.variantInfo.map((item, vIndex) => ({
            ...(formik.touched?.prices?.[i]?.variantInfo?.[vIndex] || {}),
            name: true, amount: true, quantity: item?.infiniteQuantity ? false : true,
          }));
        }
        return fields;
      });
      formik.setTouched(newTouched);
      formik.setErrors(errors);
      toastr.info('Validation', 'Please fill in all required fields before adding a new price.');
      return false;
    }
    return true;
  };

  const handleAddPrice = (title) => {
    formik.setFieldValue("prices", [
      ...formik.values?.prices,
      {
        title: title,
        amount: "",
        type: "On Registration",
        ledger: {},
        subLedger: {},
        tax_deductible: "",
        tax_type: "$",
        chargeDate: "",
        dueDate: "",
        note: "",
        is_splitted: false,
        variant: false,
        quantity: "",
        minAmount: "",
        infiniteQuantity: true,
        isRecurring: false,
        limitType: "amount",
        variantInfo: [
          {
            name: "",
            quantity: "",
            infiniteQuantity: true,
            amount: "",
            forMemberOnly: false,
          },
        ],
          isInstallmentTransaction: false,
  installmentDetailsTransaction: {
    numberOfInstallment: "",
    lastInstallmentDate: ""
  }
      },
    ]);
  };

  const handleDeletePrice = (index) => {
    const prices = formik.values?.prices;
    prices.splice(index, 1);
    formik.setFieldValue("prices", prices);
  };

  const handleEditPrice = (index, newTitle) => {
    formik.setFieldValue(`prices[${index}].title`, newTitle);
  };

  const handleReorderPrices = (sourceIndex, destinationIndex) => {
    const prices = [...formik.values.prices];
    const [movedItem] = prices.splice(sourceIndex, 1);
    prices.splice(destinationIndex, 0, movedItem);
    formik.setFieldValue("prices", prices);
  };

  const checkDuplicatePrice = (title, excludeIndex = -1) => {
    return formik.values?.prices?.some(
      (item, idx) => idx !== excludeIndex && item?.title?.toLowerCase() === title.trim().toLowerCase()
    );
  };

  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }
  const exceptThisSymbols = ["e", "E", "+", "-"];
  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const removeVariantHandler = (index, variantIndex) => {
    const variants = formik.values?.prices?.[index]?.variantInfo;
    variants.splice(variantIndex, 1);
    formik.setFieldValue(`prices[${index}].variantInfo`, variants);
  };

  const isVariantFilled = (variant) => {
    if (!variant?.name?.trim()) return false;
    if (!variant?.amount && !variant?.openAmount) return false;
    if (!variant?.infiniteQuantity && !variant?.quantity) return false;
    return true;
  };

  const canAddVariant = (index) => {
    const variants = formik.values?.prices?.[index]?.variantInfo || [];
    return variants.every(isVariantFilled);
  };

  const acceptNumbersAndGtZero = (value) => {
    const updatedValue = parseInt(value) > 0 ? parseInt(value) : "";
    return updatedValue;
  };

  const checkAmountTitle = useCallback((type) => {
    return type?.toLowerCase() === "optional" ||
      type?.toLowerCase() === "open amount"
      ? "Price"
      : "Amount";
  }, []);

  const resetVariantData = (index) => {
    formik.setFieldValue(`prices[${index}].quantity`, "");
    formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
    const hasVariant = formik.values?.prices?.[index]?.variant;
    if (hasVariant) {
      const existingVariants = formik.values?.prices?.[index]?.variantInfo || [];
      formik.setFieldValue(
        `prices[${index}].variantInfo`,
        existingVariants.map(v => ({ ...v, quantity: '', infiniteQuantity: true }))
      );
    }
  };

  const componentRender = (index) => {
    const allowInstallments =
      enableInstallments &&
      formik.values?.prices?.[index]?.type !== "No Payment Needed";

    return (
      <>
        <Row style={{ marginBottom: "20px" }}>
          <Col className="col-sm-6">
            <PaymentTypeSelect
              titleStyle={{
                fontFamily: fontConfig.GeneralPaymentTypeSelectFont.family,
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "18px",
                color: "#4F4F4F",
              }}
              title={"Type"}
              formik={formik}
              index={index}
              setCostActive={setCostActive}
              items={[
                "On Registration",
                "No Payment Needed",
                "Optional" ,
                "Open Amount",
              ]}
              value={formik.values?.prices?.[index]?.type}
            />
          </Col>
          {formik.values?.prices?.[index]?.type === "Open Amount" ? (
            <Col className="col-sm-6">
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                <label style={{ fontFamily: fontConfig.FormsCostInfoTextFont.family, fontWeight: '400', fontSize: '12px', color: '#4F4F4F', marginBottom: 0 }}>Minimum Amount <span style={{ color: 'red' }}>*</span></label>
                <InfoTooltip text="Require users to enter an amount equal to or greater than the minimum amount indicated in this field." />
              </div>
              <InputField
                titleStyle={{
                  fontFamily: fontConfig.GeneralInputFieldFont.family,
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#4F4F4F",
                }}
                style={{ color: "#002E5C" }}
                mandatory={true}
                formik={formik}
                title="none"
                name={`prices[${index}].minAmount`}
                placeholder="Minimum Amount"
                checkValidation={true}
                value={formik.values?.prices?.[index]?.minAmount || ""}
                handleChange={(e) => {
                  const { value } = e.target;
                  let updatedValue =
                    value.match(regex)[0] >= 1
                      ? value.match(regex)[0]
                      : "";
                  if (parseFloat(updatedValue) > 1000000) updatedValue = "1000000";
                  formik.setFieldValue(`prices[${index}].minAmount`, updatedValue);
                }}
                max={1000000}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                onBlur={formik.handleBlur}
              />
            </Col>
          ) : (["Optional", "On Registration", "Addons"].includes(
  formik.values?.prices?.[index]?.type
) &&
            formik.values?.prices?.[index]?.variant) ||
          formik.values?.prices?.[index]?.type ===
            "No Payment Needed" ? null : (
            <Col className="col-sm-6">
              <InputField
                titleStyle={{
                  fontFamily: fontConfig.GeneralInputFieldFont.family,
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#4F4F4F",
                }}
                style={{  color: "#002E5C" }}
                mandatory={
                  formik.values?.prices?.[index]?.type !== "Open Amount"
                }
                formik={formik}
                title={checkAmountTitle(formik.values?.prices?.[index]?.type)}
                // name="costInfo_amount"
                name={`prices[${index}].amount`} 
                placeholder={checkAmountTitle(
                  formik.values?.prices?.[index]?.type
                )}
                checkValidation={true}
                value={formik.values?.prices?.[index]?.amount || ""}
                handleChange={(e) => {
                  const { value } = e.target;
                  const minimumValue =
                    formik.values?.prices?.[index]?.type === "Optional" ||
                    formik.values?.prices?.[index]?.type === "On Registration"
                      ? 0
                      : 1;
                  let updatedValue =
                    value.match(regex)[0] >= minimumValue
                      ? value.match(regex)[0]
                      : "";
                  if (parseFloat(updatedValue) > 1000000) updatedValue = "1000000";
                  formik.setFieldValue(`prices[${index}].amount`, updatedValue);
                }}
                max={1000000}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                onBlur={formik.handleBlur}
              />
            </Col>
          )}
        </Row>
        {["Optional", "On Registration", "Addons"].includes(
  formik.values?.prices?.[index]?.type
)  && (
          <Row style={{ marginBottom: "20px" }}>
            <Col className="col-sm-6">
              <Stack
    direction={{ xs: "column", xl: "row" }}
    spacing={0}
    sx={{ flexWrap: 'wrap', gap: '4px 16px', alignItems: 'flex-start', alignContent: 'flex-start', '@media (max-width: 1558px)': { flexDirection: 'column' } }}
  >
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                <MyCheckbox
                  title="Has Variant"
                  name="variant"
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `prices[${index}].variant`,
                      e.target.checked
                    );
                    if (e.target.checked) {
                      formik.setFieldValue(`prices[${index}].quantity`, "");
                      formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
                      const existingVariants = formik.values?.prices?.[index]?.variantInfo;
                      if (!existingVariants?.length) {
                        formik.setFieldValue(`prices[${index}].variantInfo`, [{
                          name: '',
                          quantity: '',
                          infiniteQuantity: true,
                          amount: '',
                          reserveProduct: 0,
                          forMemberOnly: false,
                          openAmount: false,
                        }]);
                      } else {
                        formik.setFieldValue(`prices[${index}].variantInfo`,
                          existingVariants.map(v => ({ ...v, infiniteQuantity: true, quantity: '' }))
                        );
                      }
                    }
                  }}
                  checked={formik.values?.prices?.[index]?.variant}
                />
                <InfoTooltip text="Create multiple options for same registrations with different prices. Each variant can have its own quantity and price. E.g., Child and Adult." style={{ marginBottom: '8px' }} />
              </div>
             {    ["Optional"].includes(
  formik.values?.prices?.[index]?.type
)  && <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                <MyCheckbox
                  title="Required"
                  name="required"
                  handlechange={(e) => {
                    formik.setFieldValue(`prices[${index}].required`, e.target.checked);
                    if (e.target.checked) {
                      formik.setFieldValue(`prices[${index}].quantity`, '');
                      formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
                      const variantInfo = formik.values?.prices?.[index]?.variantInfo;
                      if (Array.isArray(variantInfo)) {
                        formik.setFieldValue(
                          `prices[${index}].variantInfo`,
                          variantInfo.map(v => ({ ...v, quantity: '', infiniteQuantity: true }))
                        );
                      }
                    }
                  }}
                  checked={formik.values?.prices?.[index]?.required}
                />
                <InfoTooltip text="Make this option mandatory for all registrants." style={{ marginBottom: '8px' }} />
              </div>}
             {    ["Optional", "On Registration", "Addons"].includes(
  formik.values?.prices?.[index]?.type
)  && <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                <MyCheckbox
                  title="Recurring"
                  name="isRecurring"
                  disabled={formik.values?.prices?.[index]?.isInstallmentTransaction}
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `prices[${index}].isRecurring`,
                      e.target.checked
                    );
                  }}
                  checked={formik.values?.prices?.[index]?.isRecurring}
                />
                <InfoTooltip text="Enable monthly recurring billing. Registrants will be charged on a recurring basis." style={{ marginBottom: '8px' }} />
              </div>}
              </Stack>
            </Col>
            {formik.values?.prices?.[index]?.type === "Optional" && (
              <Col className="col-sm-6">
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <RadioButtons
                    value={formik.values?.prices?.[index]?.limitType}
                    name={"limitType"}
                    onChange={(value) => {
                      formik.setFieldValue(`prices[${index}].limitType`, value);
                      if (value === "checkbox") {
                        resetVariantData(index);
                      }
                    }}
                    size={"small"}
                    row={true}
                    options={[
                      {
                        label: "Amount",
                        value: "amount",
                      },
                      {
                        label: "Checkbox",
                        value: "checkbox",
                      },
                    ]}
                  />
                  <InfoTooltip text="Use a checkbox for simple yes/no add-ons, and an amount field when users need to select multiple units or quantities." />
                </div>
              </Col>
            )}
          </Row>
        )}
        {(( ["Optional", "Addons"].includes(
      formik.values?.prices?.[index]?.type
    )&&
          !formik.values?.prices?.[index]?.variant) ||
          formik.values?.prices?.[index]?.type === "Open Amount") && (
            <>
          <Row style={{ marginBottom: "20px" }}>
            <Col className="col-sm-6">
              <InputField
                titleStyle={{
                  fontFamily: fontConfig.GeneralInputFieldFont.family,
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#4F4F4F",
                }}
                style={{ color: "#002E5C" }}
                mandatory={
                  formik.values?.prices?.[index]?.limitType !== "checkbox"
                }
                formik={formik}
                title="Quantity"
                name={`prices[${index}].quantity`}
                placeholder="Quantity"
                checkValidation={true}
                value={formik.values?.prices?.[index]?.quantity}
                handleChange={(e) => {
                  let value = acceptNumbersAndGtZero(
                    e?.target?.value.match(regex)[0]
                  );
                  if (parseInt(value) > 10000) value = 10000;
                  formik.setFieldValue(`prices[${index}].quantity`, value);
                }}
                max={10000}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                disabled={
                  formik.values?.prices?.[index]?.infiniteQuantity ||
                  formik.values?.prices?.[index]?.limitType === "checkbox"
                }
                onBlur={formik.handleBlur}
              />
            </Col>
            <Col className="col-sm-6">
              <Stack
                direction="row"
                spacing={2}
                style={{ marginTop: "40px" }}
              >
                <MyCheckbox
                  title="No Limit"
                  name="infiniteQuantity"
                  handlechange={(e) => {
                    formik.setFieldValue(
                      `prices[${index}].infiniteQuantity`,
                      e.target.checked
                    );
                    if (e.target.checked) {
                      formik.setFieldValue(`prices[${index}].quantity`, "");
                      formik.setFieldTouched(`prices[${index}].quantity`, false, false);
                    } else {
                      formik.setFieldTouched(`prices[${index}].quantity`, true, true);
                    }
                  }}
                  checked={formik.values?.prices?.[index]?.infiniteQuantity}
                  disabled={
                    formik.values?.prices?.[index]?.limitType === "checkbox" ||
                    formik.values?.prices?.[index]?.required === true
                  }
                />
                {["Open Amount", "Addons"].includes(formik.values?.prices?.[index]?.type) && (
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <MyCheckbox
                      title="Recurring"
                      name="isRecurring"
                      disabled={formik.values?.prices?.[index]?.isInstallmentTransaction}
                      handlechange={(e) => {
                        formik.setFieldValue(
                          `prices[${index}].isRecurring`,
                          e.target.checked
                        );
                      }}
                      checked={formik.values?.prices?.[index]?.isRecurring}
                    />
                    <InfoTooltip text="Enable monthly recurring billing. Registrants will be charged on a recurring basis." style={{ marginBottom: '8px' }} />
                  </div>
                )}
              </Stack>
            </Col>
          </Row>
          </>
        )}
        {["Optional", "On Registration", "Addons"].includes(
  formik.values?.prices?.[index]?.type
) &&
          formik.values?.prices?.[index]?.variant && (
            <>
              {formik.values?.prices?.[index]?.variantInfo?.map(
                (item, variantIndex) => (
                  <OptionalTypesItems
                    key={`${index}-${variantIndex}`}
                    formik={formik}
                    index={index}
                    variantIndex={variantIndex}
                    removeVariantHandler={removeVariantHandler}
                    acceptNumbersAndGtZero={acceptNumbersAndGtZero}
                    checkAmountTitle={checkAmountTitle}
                  />
                )
              )}
              <Row style={{ marginBottom: "20px" }}>
                <Col className="col-sm-12">
                  <button
                    className="optional_type_add_btn"
                    onClick={() => {
                      if (!canAddVariant(index)) {
                        toastr.info('Validation', 'Please fill in all variant details before adding a new one');
                        return;
                      }
                      formik.setFieldValue(`prices[${index}].variantInfo`, [
                        ...formik.values?.prices?.[index]?.variantInfo,
                        {
                          name: "",
                          quantity: "",
                          infiniteQuantity: true,
                          amount: '',
                        },
                      ]);
                    }}
                  >
                    <AddNewField />
                    Add
                  </button>
                </Col>
              </Row>
            </>
          )}
        {(["Optional", "On Registration", "Addons"].includes(
  formik.values?.prices?.[index]?.type)||
          formik.values?.prices?.[index]?.type === "Open Amount") && (
          <Row style={{ marginBottom: "20px" }}>
            <Col className="col-sm-12">
              <hr
                className="w-100 mb-5"
                style={{ borderBottom: "dashed 1px #002E5C", opacity: "0.2" }}
              />
            </Col>
          </Row>
        )}

        

        {formik.values?.prices?.[index]?.type !== "No Payment Needed" && (
          <Row style={{ marginBottom: "20px" }}>
            <Col className="col-sm-6">
              <LabelField
                mandatory
                title="Ledgers"
                titleStyle={{
                  fontFamily: fontConfig.GeneralLabelFieldFont.family,
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#4F4F4F",
                  margin: "0px",
                }}
              />
              <LedgersMenu
                ledgers={ledgers}
                formik={formik}
                index={index}
                loading={loading}
              />
            </Col>
            <Col className="col-sm-6">
              <div className="class_tax_deductible">
                <InputField
                  titleStyle={{
                    fontFamily: fontConfig.GeneralInputFieldFont.family,
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "18px",
                    color: "#4F4F4F",
                  }}
                  style={{ background: "#f6f6f6", color: "#002E5C" }}
                  formik={formik}
                  title="Tax Deductible"
                  name="tax_deductible"
                  placeholder="Tax Deductible"
                  checkValidation={true}
                  value={formik.values?.prices?.[index]?.tax_deductible ?? ""}
                  handleChange={(e) => {
                    const val = e.target.value.match(regex)[0];
                    const maxVal = formik.values?.prices?.[index]?.tax_type === '%' ? 100 : 10000;
                    if (parseFloat(val) > maxVal) return;
                    formik.setFieldValue(`prices[${index}.tax_deductible]`, val);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                <div className="tax_type">
                  <span
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].tax_type`, "$");
                      formik.setFieldValue(`prices[${index}].tax_deductible`, "");
                    }}
                    className={
                      formik.values?.prices?.[index]?.tax_type === "$"
                        ? "text-primary tax_type_selected"
                        : ""
                    }
                  >
                    {currency}
                  </span>
                  <span>|</span>
                  <span
                    onClick={() => {
                      formik.setFieldValue(`prices[${index}].tax_type`, "%");
                      formik.setFieldValue(`prices[${index}].tax_deductible`, "");
                    }}
                    className={
                      formik.values?.prices?.[index]?.tax_type === "%"
                        ? "text-primary tax_type_selected"
                        : ""
                    }
                  >
                    %
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        )}
        {formik.values?.prices?.[index]?.type === "On Approve" && (
          <Row style={{ marginBottom: "20px" }}>
            <Col className="col-sm-6">
              <LabelField title={"Charge Date"} mandatory />
              <DatePicker
                isClearable
                showIcon
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                selected={
                  formik.values?.prices?.[index]?.chargeDate &&
                  // new Date(formik?.values?.date_of_death)
                  convertUTCToLocalDate(
                    formik.values?.prices?.[index]?.chargeDate
                  )
                }
                onChange={(e) => {
                  formik.setFieldValue(`prices[${index}.chargeDate]`, e);
                  convertLocalToUTCDate(e, `prices[${index}.chargeDate]`);
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateMask}
                    keepCharPositions={true}
                    guide={true}
                  />
                }
              />
            </Col>
            <Col className="col-sm-6">
              <LabelField title={"Due Date"} mandatory />
              <DatePicker
                isClearable
                showIcon
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                selected={
                  formik.values?.prices?.[index]?.dueDate &&
                  // new Date(formik?.values?.date_of_death)
                  convertUTCToLocalDate(formik.values?.prices?.[index]?.dueDate)
                }
                onChange={(e) => {
                  formik.setFieldValue(`prices[${index}].dueDate`, e);
                  convertLocalToUTCDate(e, `prices[${index}].dueDate`);
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateMask}
                    keepCharPositions={true}
                    guide={true}
                  />
                }
              />
            </Col>
          </Row>
        )}
        <Row style={{ marginBottom: "20px" }}>
          <Col className="col-sm-12">
            <InputField
              titleStyle={{
                fontFamily: fontConfig.GeneralInputFieldFont.family,
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "18px",
                color: "#4F4F4F",
              }}
              style={{ background: "#f6f6f6", color: "#002E5C" }}
              formik={formik}
              mandatory={
                formik.values?.prices?.[index]?.required_notes ?? false
              }
              title="Note"
              name="note"
              placeholder="Note"
              checkValidation={true}
              value={formik.values?.prices?.[index]?.note ?? ""}
              handleChange={(e) =>
                formik.setFieldValue(`prices[${index}].note`, e.target.value)
              }
              maxLength={200}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </Col>
        </Row>
        <hr
          className="w-100 mb-5"
          style={{ borderBottom: "dashed 1px #002E5C", opacity: "0.2" }}
        />
        <div className="d-flex" style={{ gap: "20px" }}>
          {formik.values?.prices?.[index]?.type === "On Approve" && (
            <MyCheckbox
              title="Split Charge"
              name="split_charge"
              handlechange={(e) => {
                formik.setFieldValue(
                  `prices[${index}].is_splitted`,
                  e.target.checked
                );
                formik.setFieldValue(
                  `prices[${index}].isInstallmentTransaction`,
                  false
                );
              }}
              checked={formik.values?.prices?.[index]?.is_splitted}
              disabled={formik.values?.prices?.[index]?.type !== "On Approve"}
            />
          )}
          {allowInstallments && (
            <MyCheckbox
              title="Allow Installments"
              name="isInstallmentTransaction"
              disabled={formik.values?.prices?.[index]?.isRecurring}
              handlechange={(e) => {
                formik.setFieldValue(
                  `prices[${index}].isInstallmentTransaction`,
                  e.target.checked,true
                );
                formik.setFieldValue(`prices[${index}].is_splitted`, false);
                 const checked = e.target.checked;

  if (!checked) {
  
    formik.setFieldValue(
      `prices[${index}].installmentDetailsTransaction`,
       {
    numberOfInstallment: "",
    lastInstallmentDate: ""
  }
    );

    
    formik.setFieldTouched(
      `prices[${index}].installmentDetailsTransaction`,
      true
    );
  }


  formik.validateForm();
              }}
              checked={
                formik.values?.prices?.[index]?.isInstallmentTransaction ||
                false
              }
              onBlur={formik.handleBlur}
            />
          )}
        </div>
        {formik.values.prices[index]?.isInstallmentTransaction &&
          allowInstallments && (
            <AddInstallmentsPayment
              formik={formik}
             formikKey={`prices.${index}.installmentDetailsTransaction`}
              onInstallmentChange={(value) => {
                if (!value) {
                  formik.setFieldValue(
                    `prices.${index}.installmentDetailsTransaction.numberOfInstallment`,
                    null
                  );
                  return;
                }
                formik.setFieldValue(
                  `prices.${index}.installmentDetailsTransaction.numberOfInstallment`,
                  value?.value
                );
              }}
              onDateChange={(date) => {
                formik.setFieldValue(
                  `prices.${index}.installmentDetailsTransaction.lastInstallmentDate`,
                  date
                );
                convertLocalToUTCDate(
                  date,
                  `prices.${index}.installmentDetailsTransaction.lastInstallmentDate`
                );
              }}
              installmentValue={
                formik.values.prices[index]?.installmentDetailsTransaction
                  ?.numberOfInstallment
              }
              dateValue={
                formik.values.prices[index]?.installmentDetailsTransaction
                  ?.lastInstallmentDate &&
                convertUTCToLocalDate(
                  formik.values.prices[index]?.installmentDetailsTransaction
                    ?.lastInstallmentDate
                )
              }
              manageFromOutside={true}
            />
          )}
        {formik.values?.prices?.[index]?.is_splitted && (
          <Row>
            <div className="col-sm-5">
              <SelectField
                {...{
                  formik,
                  name: `values.${index}.split_duration`,
                  items: ["day", "week", "month", "quarter", "year"],
                  placeholder: "Select",
                  value: formik.values?.prices?.[index]?.split_duration ? (
                    <span style={{ color: "black" }}>
                      {formik.values?.prices?.[index]?.split_duration}
                    </span>
                  ) : (
                    "Select"
                  ),
                }}
                onClick={(data) =>
                  formik.setFieldValue(`prices[${index}].split_duration`, data)
                }
              />
            </div>
            {formik.values?.prices?.[index]?.split_duration ? (
              <div className="col-sm-3">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "",
                    name: `values.${index}.number_of_split`,
                    placeholder: "0",
                    value: formik.values?.prices?.[index]?.number_of_split,
                    checkValidation: true,
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  handleChange={(e) =>
                    formik.setFieldValue(
                      `prices[${index}].number_of_split`,
                      e.target.value
                    )
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                {/* <div className="placeholder-div">
                  <p>{formik.values.values?.[index]?.split_amount}</p>
                </div> */}
              </div>
            ) : (
              ""
            )}
          </Row>
        )}
      </>
    );
  };
  const total = formik.values?.prices?.reduce(
    (acc, item) => acc + Number(item.amount || 0),
    0
  );
  return (
    <div className="cost_info_container">
      <div className="cost_info_left_side">
        <div className="cost_info_title">
          <PricingTabs
            items={formik.values?.prices || []}
            activeTab={costActive}
            setActiveTab={setCostActive}
            onAdd={handleAddPrice}
            onDelete={handleDeletePrice}
            onEdit={handleEditPrice}
            onReorder={handleReorderPrices}
            duplicateCheck={checkDuplicatePrice}
            titleKey="title"
            minItems={0}
            hasError={hasPriceError}
            onBeforeAdd={handleBeforeAddPrice}
          />
        </div>
        <div class="vertical-line"></div>
      </div>
      <div className="cost_info_content">
        {formik.values?.prices?.length > 0 ? (
          componentRender(costActive)
        ) : (
          <div className="no_cost text-center">No Cost Found</div>
        )}
      </div>
    </div>
  );
};

export default PriceInfo;
